import IvrSession from 'src/models/Ivrs/IvrSession';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

const ivrSessionsResource = createCollectionResource<IvrSession>({
  name: 'ivrSessions',
  endpoint: 'v1/orgs/:orgId/ivr-sessions',
  type: IvrSession,
  observerCreator: emptyObserverCreator,
});

export default ivrSessionsResource;
